export class ListAccessPoliciesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policies",
            "baseName": "policies",
            "type": "Array<DataCatalogAccessPolicy>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAccessPoliciesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
